import React from 'react';
import { Nav, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const tabs = [
  { name: 'daily', label: '日次PL', path: '/dailyPL' },
  { name: 'monthly', label: '月次PL', path: '/monthlyPL' },
];

export default function PlTabs({ activeTab }) {
  return (
    <Nav tabs className="mb-3">
      {tabs.map(({ label, name, path }) => (
        <NavItem key={name}>
          <Link 
            className={classnames('nav-link cursor-pointer', { active: activeTab === name })}
            to={path}
          >
            {label}
          </Link>
        </NavItem>
      ))}
    </Nav>
  );
}
